export const HERO_SCENE_START_LEAD = 1500;

export function getScenePlayDelay(delayMs, leadMs = HERO_SCENE_START_LEAD) {
  const delay = toFiniteNumber(delayMs, 0);
  const lead = Math.max(0, toFiniteNumber(leadMs, HERO_SCENE_START_LEAD));

  return Math.max(0, delay - lead);
}

function toFiniteNumber(value, fallback) {
  const number = Number(value);

  return Number.isFinite(number) ? number : fallback;
}
